import { setActiveItemInputKeys } from '../../../State/activeItemInputKeys';
import sanitiseValuationItemAmount from '../../../Services/sanitiseValuationItemAmount';

export default ({ orderIndex, orderGroupIndex, orderItemIndex }) => async (dispatch) => {
  
  dispatch(setActiveItemInputKeys(null));
  dispatch(sanitiseValuationItemAmount({ orderIndex, orderGroupIndex, orderItemIndex }));

}